<app-basic-page [pageTitle]="'Pricing'">
  <div class="basic-block">
    @if (subscriptionId()) {
      <app-update-subscription-button></app-update-subscription-button>
    } @else {
      <stripe-pricing-table
        [attr.pricing-table-id]="getPricingTableId()"
        [attr.publishable-key]="getKey()"
        [attr.client-reference-id]="getClientReferenceId()"
        [attr.customer-email]="primaryEmail()"
      >
      </stripe-pricing-table>
    }
  </div>
</app-basic-page>

<script async src="https://js.stripe.com/v3/pricing-table.js"></script>
<stripe-pricing-table
  pricing-table-id="prctbl_1Q9FU9RxbnIIrwvoK45ZGWoR"
  publishable-key="pk_live_51Q8SSpRxbnIIrwvo3Y36TcqLiJjZMfzEFrIF1s3CWE8qT8giIO0xq9ziz9wKOvdivcd97B0YCSu0fCnNyr0ArYtd00kRxc7aYF"
>
</stripe-pricing-table>

<script async src="https://js.stripe.com/v3/pricing-table.js"></script>
<stripe-pricing-table
  pricing-table-id="prctbl_1Q9FagRxbnIIrwvoBjiqtG8S"
  publishable-key="pk_test_51Q8SSpRxbnIIrwvoV6bOiZpPAyLvMiVKJpTA2h5LVn1lErk0jA7Xg9XiwiQfBhcx43cdACzNiBWNvg8NRJlVPQWE00fDGnGv8H"
>
</stripe-pricing-table>
